import { PrepLessons } from 'platform-components';
import { OwnProps as PrepLessonsItemProps } from 'platform-components/src/components/prep-lessons/__item/prep-lessons__item';
import { PREP_LESSONS_THEME } from 'platform-components/src/components/prep-lessons/constants';
import React from 'react';
import SimpleMarkdown, { SingleNodeParserRule, ReactOutputRule, SingleASTNode } from 'simple-markdown';

import usePrepLessonClick, { MetrikaParams } from 'common.components/hooks/use-prep-lesson-click';

interface ConfigItem extends PrepLessonsItemProps {
    metrika: {
        goal_name: string;
        goal_params: MetrikaParams;
    };
}

export interface PrepLessonsConfig {
    theme?: PREP_LESSONS_THEME;
    items: ConfigItem[];
}

interface PrepLessonsConfigNode extends SingleASTNode {
    config: PrepLessonsConfig;
}

function isPrepLessonsConfigNode(node: SingleASTNode): node is PrepLessonsConfigNode {
    return node.config && Array.isArray(node.config.items);
}

export const prepLessonsRule: { prepLessons: SingleNodeParserRule & ReactOutputRule } = {
    prepLessons: {
        order: 0,
        // {prepLessons}JSON-STRING{/preLessons}
        match: SimpleMarkdown.inlineRegex(/^\{prepLessons\}(.*?)\{\/prepLessons\}/),
        parse(capture) {
            try {
                const config: PrepLessonsConfig = JSON.parse(capture[1]);

                return {
                    config,
                };
            } catch (e) {
                console.error(e);
                return {
                    config: { items: [] },
                };
            }
        },
        react(node) {
            const config: PrepLessonsConfig = isPrepLessonsConfigNode(node) ? node.config : { items: [] };

            return <RuleComponent config={config} />;
        },
    },
};

const RuleComponent = ({ config }: { config: PrepLessonsConfig }) => {
    const { handlePrepLessonClick } = usePrepLessonClick();

    return (
        <PrepLessons mix="promo__prep-lessons" theme={config.theme}>
            {config.items.map(({ metrika, ...props }) => {
                return (
                    <PrepLessons.Item
                        {...props}
                        onClick={() => {
                            handlePrepLessonClick(props.lesson.id, metrika ? metrika.goal_params : {});
                        }}
                    />
                );
            })}
        </PrepLessons>
    );
};
